(function () {
  'use strict';

  angular
      .module('eltazkara.handler', [])

})();
